import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IStockLocation } from '@stockcare-models/IStock-location';
import { ConfigService } from '@stockcare-services/config-service/config.service';

@Injectable({
    providedIn: 'root'
})
export class StockLocationsService {
    constructor(private http: HttpClient, private conf: ConfigService) {}

    getByInstitution(institutionId: number): Observable<IStockLocation[]> {
        return this.http.get<IStockLocation[]>(
            `${
                this.conf.config.baseUrl
            }/stocklocations/institution/${institutionId}`
        );
    }
}
